/**
 * Frontend configuration utility
 */

export const isProduction = () => {
  return window.location.hostname === 'app.cogniflock.com';
};

export const isDevelopment = () => {
  return !isProduction();
};

export const useMockData = () => {
  // Always use real data from the database, never mock data
  return false;
};

export const shouldBypassSlackConnection = () => {
  // Bypass Slack connection requirement when using mock data in development
  return useMockData();
}; 